import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--cdj-form"
export default class extends Controller {
    connect() {
        //console.log('CDJFormController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-custom-jewelry-request');
        if (!form) {
            console.error('Custom jewelry request form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'custom_jewelry_request[jewelry]': {
                    validators: {
                        notEmpty: {
                            message: 'Please select the type of jewelry'
                        }
                    }
                },
                'custom_jewelry_request[metal]': {
                    validators: {
                        notEmpty: {
                            message: 'Please select the desired metal'
                        }
                    }
                },
                'custom_jewelry_request[description]': {
                    validators: {
                        notEmpty: {
                            message: 'Please provide a description of your custom jewelry'
                        }
                    }
                },
                'custom_jewelry_request[name]': {
                    validators: {
                        notEmpty: {
                            message: 'Your name is required'
                        }
                    }
                },
                'custom_jewelry_request[email]': {
                    validators: {
                        notEmpty: {
                            message: 'Email address is required'
                        },
                        emailAddress: {
                            message: 'Please enter a valid email address'
                        }
                    }
                },
                'custom_jewelry_request[phone]': {
                    validators: {
                        notEmpty: {
                            message: 'Phone number is required'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.mb-3',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                }),
                aria: new plugins.Aria()
            }
        })
            .on('core.form.valid', (e) => {
                // Form is valid, proceed with submission
                const submitEvent = new Event('submit', {bubbles: true, cancelable: true});
                form.dispatchEvent(submitEvent);
            })
            .on('core.form.invalid', (e) => {
                // Form is invalid, prevent submission
                e.preventDefault();
                return false;
            });
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
